import { Reducer } from 'redux';

import { mapIdToData } from '~src/utils';
import { getCycles, RESET_CYCLES } from '~src/shared/sidebar/constants/actionTypes';
import { CycleI } from '~src/interfaces/cycle.interface';
import { ThunkFailAction, ThunkSuccessAction } from '~src/services/apiMiddleware';

export interface CycleState {
  loading: boolean;
  error: any;
  byId: Record<string, CycleI> | null;
  initialLoaded: boolean;
}

export function getInitialCyclesState(): CycleState {
  return {
    loading: false,
    error: null,
    byId: null,
    initialLoaded: false,
  };
}

const cyclesReducer: Reducer<CycleState, ThunkSuccessAction | ThunkFailAction> = (
  state = getInitialCyclesState(),
  action,
) => {
  switch (action.type) {
    case getCycles.Request: {
      return { ...state, loading: true };
    }
    case getCycles.Success: {
      return {
        ...state,
        loading: false,
        byId: mapIdToData(action.response.data),
        initialLoaded: true,
      };
    }
    case getCycles.Failed: {
      return { ...state, loading: false, error: action.payload };
    }
    case RESET_CYCLES: {
      return { ...state, byId: {} };
    }
    default:
      return state;
  }
};

export default cyclesReducer;
